import { FC } from 'react';

import { QrStyle, resolveImageSrc } from '../../../api/client';
import { Button, Field, FileTrigger, Stack } from '../../../ui';
import { LogoDisplay } from './types';

// A style needs the picture's light areas for the code to stay readable, so the
// advice only belongs on the styles that draw the picture.
const PICTURE_STYLES: QrStyle[] = ['halftone', 'photo'];

type QrImageFieldProps = {
  logo: LogoDisplay;
  style: QrStyle;
  uploading: boolean;
  onChoose: (file: File) => void;
  onRemove: () => void;
};

/**
 * The branding image control: the current thumbnail, its name and the replace
 * or remove actions. The picker is the shared trigger, so it carries the button
 * contract instead of a page-local label-wrapped input.
 */
const QrImageField: FC<QrImageFieldProps> = ({ logo, style, uploading, onChoose, onRemove }) => (
  <Field
    label="Image"
    group
    span="full"
    description={PICTURE_STYLES.includes(style) ? 'Halftone and Picture background read better when the image has light areas.' : undefined}
  >
    <div className="paymentLogoRow">
      {logo.url ? (
        <img className="paymentLogoThumb" src={resolveImageSrc(logo.url)} alt="Current QR code" crossOrigin="anonymous" />
      ) : (
        <span className="paymentLogoEmpty">none</span>
      )}
      <Stack gap={2}>
        <span className="paymentLogoName">{logo.url ? (logo.name ?? 'Uploaded image') : 'No image uploaded'}</span>
        <div className="paymentLogoControls">
          <FileTrigger accept="image/png,image/jpeg,image/webp" onFile={onChoose} disabled={uploading} variant="secondary" size="sm">
            {uploading ? 'Uploading…' : logo.url ? 'Replace image' : 'Upload image'}
          </FileTrigger>
          {logo.url && (
            <Button variant="ghost" size="sm" onClick={onRemove}>
              Remove
            </Button>
          )}
        </div>
      </Stack>
    </div>
  </Field>
);

export default QrImageField;
